import { createGlobalStyle } from 'styled-components'

import SFProRegular from '@/fonts/sf-pro-display-regular.woff2'
import SFProMedium from '@/fonts/sf-pro-display-medium.woff2'
import SFProSemiBold from '@/fonts/sf-pro-display-semibold.woff2'
import SFProBold from '@/fonts/sf-pro-display-bold.woff2'
import { E_Colors } from '@/helpers/colors'
import { E_ZIndexes } from './helpers/consts'


export const AppGlobalStyled = createGlobalStyle`
  @font-face {
    font-family: 'SFPro';
    font-weight: 400;
    src: url(${SFProRegular}) format('truetype');
  }

  @font-face {
    font-family: 'SFPro';
    font-weight: 500;
    src: url(${SFProMedium}) format('truetype');
  }

  @font-face {
    font-family: 'SFPro';
    font-weight: 600;
    src: url(${SFProSemiBold}) format('truetype');
  }

  @font-face {
    font-family: 'SFPro';
    font-weight: 700;
    src: url(${SFProBold}) format('truetype');
  }

  html {
    background-color: ${E_Colors.GrayF5F5F7};
  }

  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin: 0;
    color: ${E_Colors.TextPrimary};
    font-size: 14px;
    font-family: 'SFPro';
    background-color: ${E_Colors.GrayF5F5F7};

    * {
      box-sizing: border-box;

      @media (max-width: 900px) {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        -webkit-touch-callout: none;
      }
    }
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  a {
    color: ${E_Colors.Gray3B};
    text-decoration: none;
  }

  h1 {
    font-stretch: expanded;
    font-size: 28px;
    color: ${E_Colors.TextPrimary};
    font-style: normal;
    line-height: 120%;
    margin: 0;
  }

  h2 {
    font-size: 22px;
    color: ${E_Colors.TextPrimary};
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin: 0;
  }

  h3 {
    font-size: 17px;
    color: ${E_Colors.TextPrimary};
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin: 0;
  }

  h4 {
    font-size: 14px;
    color: ${E_Colors.TextPrimary};
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin: 0;
  }

  h5 {
    font-size: 16px;
    color: ${E_Colors.TextPrimary};
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin: 0;
  }

  p {
    font-size: 13px;
    font-style: normal;
    color: ${E_Colors.TextPrimary};
    font-weight: 400;
    line-height: normal;
    margin: 0;
  }

  [id^='drawer-portal'] {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: ${E_ZIndexes.Level8};
  }

  .select-dropdown {
    border-radius: 24px !important;
    padding: 16px !important;

    .ant-select-item {
      height: 52px !important;
      align-items: center !important;
      font-size: 16px !important;
      font-weight: 400 !important;
      border-radius: 8px !important;
    }

    .ant-select-item-option-active {
      font-weight: 400 !important;
      background-color: rgba(218, 198, 239, 0.3) !important;
    }
  }
`
